'use client';
import { useRef, useState } from 'react';
import { useBaseInput } from '@THC/components/__primitives__/InputWrapper';
import { combineRefs } from '@THC/utils/helpers';
import styles from './Input.module.scss';
export const useInput = (hookProps) => {
    const { props, ref } = hookProps;
    const { withRef = true } = props;
    const { inputProps, ...rest } = useBaseInput(hookProps);
    const inputRef = useRef(null);
    const { __initialInputType, onChange, type = 'text', value, } = props.formProps?.input || {};
    const showClearInputButton = type === 'search' && (value?.length || 0) > 0;
    const [inputType, setInputType] = useState(__initialInputType || type);
    const onClearInputButtonClick = () => {
        onChange?.({ target: { value: '' } });
        inputRef.current?.focus?.();
    };
    const onTogglePasswordVisibility = () => {
        setInputType((prevType) => (prevType === 'password' ? 'text' : 'password'));
    };
    return {
        ...rest,
        clearInputButtonProps: {
            'aria-label': 'Clear search input',
            className: styles.clearButton,
            onClick: onClearInputButtonClick,
        },
        inputProps: {
            ...inputProps,
            ...(withRef ? { ref: combineRefs([ref, inputRef]) } : {}),
            type: inputType,
        },
        inputType,
        passwordVisibleProps: {
            'aria-label': 'Show password',
            'aria-pressed': inputType !== 'password',
            className: styles.passwordVisibilityButton,
            onClick: onTogglePasswordVisibility,
        },
        showClearInputButton,
    };
};
